import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/common.css';
import { Index } from './component/Index';

const documentBody = document.querySelector('div.view-wrap');
const AppView = ReactDOM.createRoot(documentBody);
AppView.render(<Index />);